import Button from "components/form/Button";
import { AppSectionsContext } from "hooks/AppSectionsContextProvider";
import * as React from "react";
import { ArrowRight } from "react-feather";
import HighlightsSectionDrawer from "./HighlightsSectionDrawer";

type Props = {
  onClose: () => void;
};

const Highlights: React.FC<Props> = (props) => {
  const context = React.useContext(AppSectionsContext);
  const [visible, setVisible] = React.useState(false);

  return (
    <div className="bg-purple-40 text-center p-5 rounded-2lg">
      <p className="mb-2.5 text-lg font-bold">Highlights</p>
      <p className="text-m mb-2.5">
        Highlights help you to promote products. <br /> Products displayed in highlights will be easily discoverable by
        your customers right in App homepage.
      </p>
      <img src="/img/highlights-in-app.png" className="mx-auto mb-2.5" />
      <Button size="large" color="green" onClick={() => setVisible(true)}>
        Continue
        <ArrowRight size={24} className="ml-10" />
      </Button>
      {visible && (
        <HighlightsSectionDrawer
          destroyOnClose
          style={{ transform: "none !important" }}
          isNew={true}
          isVisible={visible}
          onClose={() => setVisible(false)}
          onUpdate={() => {
            props.onClose();
            context.loadSections && context.selectedVenue?.id && context.loadSections(context.selectedVenue?.id, true);
          }}
        />
      )}
    </div>
  );
};

export default Highlights;
